<header class="sticky top-0 z-40 bg-white shadow-sm border-b border-gray-100">
  <!-- Top Bar: Logo, Search, Action Badges -->
  <div class="max-w-7xl mx-auto px-4 py-3">
    <div class="flex items-center justify-between gap-4">
      <!-- Mobile menu button -->
      <button type="button" class="lg:hidden text-gray-700 p-1" (click)="mobileMenuOpen.set(true)" aria-label="Abrir menú">
        <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M3 12h18M3 18h18" /></svg>
      </button>

      <!-- Logo & Brand Name -->
      <a [routerLink]="['/' + configService.currentSlug()]" reloadIfCurrent class="flex items-center gap-3 shrink-0">
        @if (configService.branding().logoUrl) {
          <img [src]="configService.branding().logoUrl" [alt]="configService.branding().siteName" class="h-10 w-auto object-contain max-w-[160px]" />
          <span class="font-extrabold text-xl text-gray-900 tracking-tight hidden sm:inline">{{ configService.branding().siteName }}</span>
        } @else {
          <div class="w-10 h-10 rounded-xl bg-primary-600 flex items-center justify-center text-white font-black text-xl uppercase shadow-md">
            {{ configService.branding().siteName ? configService.branding().siteName.charAt(0) : 'F' }}
          </div>
          <span class="font-extrabold text-xl text-gray-900 tracking-tight hidden sm:inline">{{ configService.branding().siteName || 'FAISEN' }}</span>
        }
      </a>

      <!-- Center Search Bar (Desktop) -->
      <div class="hidden md:block flex-1 max-w-2xl px-4">
        <app-search-bar />
      </div>

      <!-- Action Items: Wishlist, Cart, Account -->
      <div class="flex items-center gap-4 sm:gap-6">
        <!-- Tiendas: vuelve al directorio de tiendas -->
        <a routerLink="/" reloadIfCurrent title="Ver todas las tiendas" aria-label="Ver todas las tiendas" class="flex items-center gap-2 text-gray-700 hover:text-primary-600 transition-colors group">
          <svg class="w-6 h-6 group-hover:scale-110 transition-transform" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7" /><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" /><path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4" /><path d="M2 7h20" /><path d="M22 7v3a2 2 0 0 1-2 2 2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7" /></svg>
          <span class="text-xs font-semibold hidden xl:inline">Tiendas</span>
        </a>

        <!-- Wishlist -->
        <a [routerLink]="['/' + configService.currentSlug() + '/favoritos']" class="flex items-center gap-2 text-gray-700 hover:text-primary-600 transition-colors group">
          <div class="relative">
            <svg class="w-6 h-6 group-hover:scale-110 transition-transform" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z" /></svg>
            @if (favorites.count() > 0) {
              <span class="absolute -top-1.5 -right-1.5 w-4 h-4 rounded-full bg-accent text-white text-[10px] font-bold flex items-center justify-center shadow">
                {{ favorites.count() }}
              </span>
            }
          </div>
          <span class="text-xs font-semibold hidden xl:inline">Favoritos</span>
        </a>

        <!-- Cart -->
        <a [routerLink]="['/' + configService.currentSlug() + '/carrito']" class="flex items-center gap-2 text-gray-700 hover:text-primary-600 transition-colors group">
          <div class="relative">
            <svg class="w-6 h-6 group-hover:scale-110 transition-transform" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6" /></svg>
            @if (cart.totalItems() > 0) {
              <span class="absolute -top-1.5 -right-1.5 w-4 h-4 rounded-full bg-accent text-white text-[10px] font-bold flex items-center justify-center shadow">
                {{ cart.totalItems() }}
              </span>
            }
          </div>
          <span class="text-xs font-semibold hidden xl:inline">Carrito</span>
        </a>

        <!-- User Menu -->
        <div class="relative" (mouseenter)="userMenuOpen.set(true)" (mouseleave)="userMenuOpen.set(false)">
          <button type="button" class="flex items-center gap-2 text-gray-700 hover:text-primary-600 transition-colors" aria-label="Cuenta">
            <div class="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 font-semibold border border-gray-200 overflow-hidden">
              @if (auth.user()?.avatarUrl; as avatar) {
                <img [src]="avatar" alt="" referrerpolicy="no-referrer" class="w-full h-full object-cover" />
              } @else {
              <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
              }
            </div>
            <span class="text-xs font-semibold hidden xl:inline">
              {{ auth.isAuthenticated() ? auth.user()!.firstName : 'Mi cuenta' }}
            </span>
          </button>
          @if (userMenuOpen()) {
            <div class="absolute top-full right-0 pt-2 w-48 z-50">
              <div class="bg-white rounded-xl shadow-xl border border-gray-100 py-2 text-sm">
                  <a [routerLink]="['/' + configService.currentSlug() + '/pedidos']" class="block px-4 py-2 text-gray-700 hover:bg-gray-50">Mis pedidos</a>
                @if (auth.isAuthenticated()) {
                  <div class="px-4 py-2 text-xs font-bold text-gray-400 border-b border-gray-100 uppercase truncate">{{ auth.user()!.firstName }} {{ auth.user()!.lastName }}</div>
                  <a routerLink="/cuenta" class="block px-4 py-2 text-gray-700 hover:bg-gray-50">Mi cuenta</a>
                  <button type="button" class="w-full text-left px-4 py-2 text-red-600 hover:bg-gray-50 font-medium" (click)="logout()">Cerrar sesión</button>
                } @else {
                  <a routerLink="/auth/login" [queryParams]="{ returnTo: currentUrl() }" class="block px-4 py-2 text-gray-700 hover:bg-gray-50">Iniciar sesión</a>
                  <a routerLink="/auth/register" [queryParams]="{ returnTo: currentUrl() }" class="block px-4 py-2 text-gray-700 hover:bg-gray-50 font-semibold text-primary-600">Crear cuenta</a>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Search Mobile -->
    <div class="md:hidden pt-2">
      <app-search-bar />
    </div>
  </div>

  <!-- Bottom Navigation Bar (Primary Brand Color Background) -->
  <div class="bg-primary-600 text-white shadow-inner">
    <div class="max-w-7xl mx-auto px-4 flex items-center justify-between h-12">

      <!-- Left: Browse Categories Dropdown -->
      @if (hasCategories()) {
      <div class="relative h-full flex items-center" (mouseenter)="browseCategoriesOpen.set(true)" (mouseleave)="browseCategoriesOpen.set(false)" (keydown.escape)="browseCategoriesOpen.set(false)">
        <button
          type="button"
          (click)="browseCategoriesOpen.set(!browseCategoriesOpen())"
          [attr.aria-expanded]="browseCategoriesOpen()"
          class="h-full flex items-center gap-2 bg-black/15 hover:bg-black/25 text-white font-bold text-xs uppercase tracking-wider px-4 transition-colors cursor-pointer"
        >
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/></svg>
          <span>Explorar categorías</span>
          <svg class="w-3.5 h-3.5 ml-1 opacity-80" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 9 6 6 6-6" /></svg>
        </button>

        @if (browseCategoriesOpen()) {
          <div class="absolute top-full left-0 w-64 pt-0 z-50">
            <div class="bg-white rounded-b-xl shadow-2xl border border-gray-100 py-2 text-gray-800">
              @for (cat of categories(); track cat.id) {
                <a [routerLink]="['/' + configService.currentSlug() + '/categorias', cat.slug]" class="flex items-center justify-between px-4 py-2.5 text-xs font-medium hover:bg-gray-50 hover:text-primary-600 transition-colors">
                  <span>{{ cat.name }}</span>
                  @if (cat.productCount !== undefined) {<span class="text-[10px] bg-gray-100 text-gray-500 rounded-full px-2 py-0.5">{{ cat.productCount }}</span>}
                </a>
              }
            </div>
          </div>
        }
      </div>
      }

      <!-- Center Links -->
      <nav class="hidden lg:flex items-center gap-6 text-xs font-bold uppercase tracking-wider h-full">
        <a [routerLink]="['/' + configService.currentSlug()]" [class]="navClass('home')" [attr.aria-current]="activeNav() === 'home' ? 'page' : null">Inicio</a>
@if (hasType('PRODUCT')) {
        <a [routerLink]="['/' + configService.currentSlug() + '/productos']" [class]="navClass('products')" [attr.aria-current]="activeNav() === 'products' ? 'page' : null">Productos</a>
        }
        @if (hasType('KIT')) {
        <a [routerLink]="['/' + configService.currentSlug() + '/productos']" [queryParams]="{ tipo: 'KIT' }" [class]="navClass('kits') + ' flex items-center gap-1.5'" [attr.aria-current]="activeNav() === 'kits' ? 'page' : null">
          <span class="bg-white/20 text-white text-[9px] font-black px-1.5 py-0.5 rounded border border-white/30">COMBOS</span>
          Kits
        </a>
        }
@if (hasType('SERVICE')) {
        <a [routerLink]="['/' + configService.currentSlug() + '/productos']" [queryParams]="{ tipo: 'SERVICE' }" [class]="navClass('services')" [attr.aria-current]="activeNav() === 'services' ? 'page' : null">Servicios</a>
        }
@if (hasCategories()) {
        <a [routerLink]="['/' + configService.currentSlug() + '/categorias']" [class]="navClass('categories')" [attr.aria-current]="activeNav() === 'categories' ? 'page' : null">Categorías</a>
        }
      </nav>

      <!-- Right: atención por WhatsApp (solo si el negocio configuró el número) -->
      @if (whatsappHref(); as href) {
      <a [href]="href" target="_blank" rel="noopener" class="flex items-center gap-2.5 text-xs h-full hover:opacity-90" aria-label="Atención por WhatsApp (abre en otra pestaña)">
        <div class="w-7 h-7 rounded-full bg-white text-primary-600 flex items-center justify-center shadow shrink-0">
          <svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></svg>
        </div>
        <div class="hidden sm:block leading-tight">
          <span class="block text-[10px] text-white/70 uppercase tracking-wide">Atención</span>
          <span class="font-bold text-white text-xs tracking-wider">{{ configService.config().whatsappNumber }}</span>
        </div>
      </a>
      } @else {
        <span class="w-7" aria-hidden="true"></span>
      }
    </div>
  </div>
</header>

<!-- Mobile Drawer -->
@if (mobileMenuOpen()) {
  <div class="fixed inset-0 z-50 lg:hidden">
    <div class="absolute inset-0 bg-black/50 backdrop-blur-sm" (click)="mobileMenuOpen.set(false)"></div>
    <aside class="absolute inset-y-0 left-0 w-80 bg-white shadow-2xl flex flex-col">
      <div class="flex items-center justify-between px-5 h-16 bg-primary-600 text-white">
        <span class="font-bold text-base uppercase tracking-wider">Menú Principal</span>
        <button type="button" class="text-white/80 hover:text-white" (click)="mobileMenuOpen.set(false)" aria-label="Cerrar">
          <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12" /></svg>
        </button>
      </div>
      <nav class="flex flex-col p-4 text-sm font-medium text-gray-700 overflow-y-auto space-y-1">
        <a [routerLink]="['/' + configService.currentSlug()]" class="px-3 py-2.5 rounded-lg hover:bg-gray-100" (click)="mobileMenuOpen.set(false)">Inicio</a>
@if (hasType('PRODUCT')) {
        <a [routerLink]="['/' + configService.currentSlug() + '/productos']" class="px-3 py-2.5 rounded-lg hover:bg-gray-100" (click)="mobileMenuOpen.set(false)">Productos</a>
        }
@if (hasType('KIT')) {
        <a [routerLink]="['/' + configService.currentSlug() + '/productos']" [queryParams]="{ tipo: 'KIT' }" class="px-3 py-2.5 rounded-lg hover:bg-gray-100" (click)="mobileMenuOpen.set(false)">Combos & Kits</a>
        }
@if (hasType('SERVICE')) {
        <a [routerLink]="['/' + configService.currentSlug() + '/productos']" [queryParams]="{ tipo: 'SERVICE' }" class="px-3 py-2.5 rounded-lg hover:bg-gray-100" (click)="mobileMenuOpen.set(false)">Servicios</a>
        }
        @if (hasCategories()) {
        <a [routerLink]="['/' + configService.currentSlug() + '/categorias']" class="px-3 py-2.5 rounded-lg hover:bg-gray-100" (click)="mobileMenuOpen.set(false)">Categorías</a>
        <div class="pt-4 border-t border-gray-100 mt-2">
          <span class="px-3 text-xs uppercase font-bold text-gray-400">Categorías destacadas</span>
          <div class="mt-2 space-y-1">
            @for (cat of categories(); track cat.id) {
              <a [routerLink]="['/' + configService.currentSlug() + '/categorias', cat.slug]" class="px-3 py-2 rounded-lg hover:bg-gray-50 flex items-center justify-between text-xs text-gray-600" (click)="mobileMenuOpen.set(false)">
                <span>{{ cat.name }}</span>
                @if (cat.productCount !== undefined) {<span class="text-[10px] bg-gray-100 text-gray-500 rounded-full px-2 py-0.5">{{ cat.productCount }}</span>}
              </a>
            }
          </div>
        </div>
        }
      </nav>
    </aside>
  </div>
}
